import type { SVGProps } from "react";
// generated from ChevronLeft.svg — do not edit manually
// prettier-ignore
export default function ChevronLeft(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 15 6 L 9 12 L 15 18" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
